<template>
    <div>
        <data-filter-item :ref="filterItem.ref" v-for="(filterItem, filterIndex) in filterData" :key="filterIndex"
            :label="filterItem.label"
            :type="filterItem.type"
            :value="filterItem.value"
            :placeholder="filterItem.placeholder"
            :objectKey="filterItem.objectKey">
        </data-filter-item>
        <div class="row">
            <div class="offset-sm-3 offset-xl-2 col-sm-9 col-xl-10">
                <button type="button" class="btn btn-primary btn-primary-insv mr-2 mb-2" @click="filterSearch">
                    {{searchText}}
                </button>

                <button type="button" class="btn btn-secondary mr-2 mb-2" @click="filterReset">
                    {{clearSearchText}}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import dataFilterItem from './item';
export default {
    'name': 'DataFilter',
    'components': {
        dataFilterItem
    },
    'props': {
        'filters': {
            'type': Array,
            default () {
                return [];
            }
        },
        'searchText': {
            'type': String,
            'default': 'Search'
        },
        'clearSearchText': {
            'type': String,
            'default': 'Clear Filter'
        }
    },
    mounted () {
        this.filterData = this.filters;

        this.filterData.forEach((item) => {
            item.ref = `selector-${item.objectKey}`;
        });
    },
    data () {
        return {
            'filterData': []
        };
    },
    'methods': {
        filterSearch (shouldResetPaging = true) {
            // console.log('submit');
            // create a non tracked list
            let data = [];
            this.filterData.forEach((item) => {
                let ref = item.ref;
                if (this.$refs[ref] && this.$refs[ref][0]) {
                    let value = this.$refs[ref][0].getValue();

                    let filter = Object.assign({}, item);

                    filter.value = value;

                    data.push(filter);
                }
            });

            // emit the non tracked list instead
            this.$emit('filterSearch', {
                data,
                shouldResetPaging
            });
        },
        filterReset (shouldResetPaging = true) {
            let references = this.filterData.map((item) => item.ref);

            references.forEach((ref) => {
                if (this.$refs[ref] && this.$refs[ref][0]) {
                    this.$refs[ref][0].resetSearch();
                }
            });

            this.$emit('filterReset', {
                'data': this.filterData,
                shouldResetPaging
            });
        }
    }
};
</script>
